import { TimeService_timeServiceGetGetTime } from '@festina/collcalc-general-types/collcalc-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchCollCalcTimeNoSuspense =
  TimeService_timeServiceGetGetTime.useQuery
